__turbopack_context__.v({
  "renameProjectModal": "ConnectionsRenameModal-module__zHXnHW__renameProjectModal",
});
